/* Presentation only: retain the original server-rendered product sections and commerce handlers. */
(() => {
  document.querySelectorAll('.routine-switch [data-pdp-period]').forEach(button => {
    if(button.dataset.pdpPeriod === 'morning') button.textContent = 'Ranní péče';
    if(button.dataset.pdpPeriod === 'evening') button.textContent = 'Večerní péče';
  });
  document.querySelectorAll('[data-product-details]').forEach(root => {
    const sections = [...root.children];
    const inci = sections.filter(s => s.matches('.inci-section'));
    if (!inci.length) return;
    const id = `nr-details-${root.dataset.productDetails}`;
    const nav = document.createElement('div');
    nav.className = 'nr-detail-tabs container';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Podrobnosti produktu');
    const panels = [document.createElement('div'), document.createElement('div')];
    const buttons = ['Popis produktu', 'INCI'].map((label, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = label;
      button.id = `${id}-tab-${index}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `${id}-panel-${index}`);
      const panel = panels[index];
      panel.id = `${id}-panel-${index}`;
      panel.className = 'nr-detail-panel';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      panel.tabIndex = 0;
      nav.append(button); return button;
    });
    sections.forEach(section => panels[inci.includes(section) ? 1 : 0].append(section));
    root.prepend(nav);root.append(...panels);
    const select = (index, focus=false) => {
      buttons.forEach((button,i)=>{
        button.setAttribute('aria-selected', String(i===index));button.tabIndex=i===index?0:-1;
        panels[i].hidden=i!==index;
        if(i===1 && i===index) panels[i].querySelectorAll("details[data-inci]").forEach(d=>d.open=true);
      });
      if(focus) buttons[index].focus();
    };
    buttons.forEach((button,index)=>{
      button.addEventListener('click',()=>select(index));
      button.addEventListener('keydown',event=>{
        let next;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft')next=1-index;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=1;
        if(next!==undefined){event.preventDefault();select(next,true);}
      });
    });
    const showAnchor=()=>{
      let anchor;try{anchor=document.getElementById(decodeURIComponent(location.hash.slice(1)));}catch{return;}
      if(anchor&&root.contains(anchor)){
        select(panels[1].contains(anchor)?1:0);
        requestAnimationFrame(()=>anchor.scrollIntoView({block:'start'}));
      }
    };
    select(0);showAnchor();window.addEventListener('hashchange',showAnchor);
  });
})();
